<template lang="pug">
  .main
    v-container(style="max-width: 600px;")
      h5.text-center.my-8.primary--text.text--darken-3(v-if="this.$vuetify.breakpoint.xs") {{ $t('tell_us_about') }}
      v-card.mt-4.px-2.py-4(flat :tile="this.$vuetify.breakpoint.xs" :class="{'px-8': !this.$vuetify.breakpoint.xs}")
        v-card-text
          v-form(ref="form" v-model="valid")
            p.mb-1.label.basic600--text.text-uppercase {{ $t('company_name') }}
            v-text-field.pt-2(color="primary" v-model="name" type="text"  outlined required :rules="rules.name" dense solo flat background-color="basic200" height="40")
              template(v-slot:label)
                .p1.basic500--text {{ $t('company_name_placeholder') }}
            template(v-if="subdomainRequired")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('subdomain') }}
              v-text-field.pt-2(ref="subdomain" color="primary" v-model="subdomain" @focus="onFocusSubdomain" @blur="checkSubdomain" :success-messages="subdomainSuccess" :error-messages="subdomainErrors" type="text"  outlined :hint="subdomain.length > 2 ? `Your Yezza homepage will become https://${subdomain}.${baseDomain}` : ''" :suffix="`.${baseDomain}`" :persistent-hint="false" required :rules="rules.subdomain" dense solo flat background-color="basic200"    height="40")
                template(v-slot:label)
                  .p1.basic500--text {{ $t('subdomain') }}
            p.mb-1.label.basic600--text.text-uppercase {{ $t('phone_number') }}
            y-phone-input.my-4(v-model="phone")
            p.mb-1.label.basic600--text.text-uppercase {{ $t('staff_count') }}
            v-select.pt-2(v-model="headcount"  outlined :items="headcounts" item-text="text" item-value="value" item color="primary" required :rules="rules.headcount" dense solo flat background-color="basic200" height="40")
              template(v-slot:label)
                .p1.basic500--text {{ $t('staff_count_placeholder') }}
            template(v-if="showBusinessCategory")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('business_category') }}
              v-select.pt-2(v-model="companyExtraData.business_category.name"  outlined :items="categories" item-text="text" item-value="value" item color="primary" required :rules="rules.category" dense solo flat background-color="basic200" height="40")
                template(v-slot:label)
                  .p1.basic500--text {{ $t('business_category_placeholder') }}
              .others-category(v-if="companyExtraData.business_category.name == 'Others'")
                v-text-field.mt-n2(color="primary" v-model="companyExtraData.business_category.other_name" type="text"  outlined required :rules="rules.others_category" dense solo flat background-color="basic200" height="40")
                  template(v-slot:label)
                    .p1.basic500--text {{ $t('enter_business_category') }}
          v-btn.font-weight-bold.button-AA-medium(color="info500" dark x-large block depressed @click="submit" :loading="loading" height="40")
            div.basic100--text {{ $t('submit') }}

    .modals
      y-dialog(v-model='showSubDomainAlert', max-width='360' persistent)
        v-card
          v-card-title.pt-8.h6.primary--text {{ $t('about_subdomain') }}
          v-card-text
            p.p1(style="color: #848484" v-html="$t('about_subdomain_desc')")
          v-card-actions
            v-spacer
            v-btn.button-AA-medium(text @click='showSubDomainAlert = false')
              div.textColorAccent--text {{ $t('i_understand') }}

</template>

<script>
import { DateTime } from 'luxon'
import { setOptions, bootstrap } from 'vue-gtag'
import Cookies from 'js-cookie'
import TopBar from '@/components/TopBar.vue'
import { mapState, mapActions } from 'vuex'


export default {
  components: { TopBar },
  data: () => ({
    os:'clinic',
    subdomainRequired: true,
    loading: false,
    datta: null,
    valid: false,
    showSubDomainAlert: false,
    items: ['1 person', '2 - 10', '10 - 20', '20 - 30', '30 - 40', '40 - 50', '50 - 60', '60 - 70', '70 - 80', '80 - 90', '90 - 100', '>100'],
    name: '',
    subdomain: '',
    headcount: '',
    currency: 'MYR',
    phone: '',
    plans: [ { text: 'Start', value: 2 }, { text: 'Growth', value: 3 }],
    selectedPlan: null,
    showBusinessCategory: true,
    categories: ['GP Clinic' , 'Dental Clinic', 'Beauty Clinic', 'Specialist Clinic', 'Veterinary Clinic', 'Therapy Centre'],
    currencies: [],
    products: [
      { text: 'Yezza', value: 'yezza' },
      { text: 'Books', value: 'books' },
      { text: 'Yezza + Books', value: 'yezza,books' }
    ],
    companyExtraData: {
      business_category: {
        name: '',
        other_name: ''
      }
    },
    rules: {
      name: [
        v => !!v || 'Company Name is required'
      ],
      subdomain: [
        v => !!v || 'Subdomain is required',
        v => (v || '').length > 2 || `Must be 3 characters and above`,
        v => /^[a-zA-Z0-9-]*?$/.test(v) || 'Subdomain must be valid',
        v => v.charAt(v.length - 1) != '-' || `Must not end with '-' sign`,
      ],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ],
      headcount: [
        v => !!v || 'Select Sales Person / Agent Count'
      ],
      plan: [
        v => !!v || 'Select Your Plan'
      ],
      category: [
        v => !!v || 'Select Business category'
      ],
      currency: [
        v => !!v || 'Select account currency'
      ],
      others_category: [
        v => !!v || 'Business category is required'
      ],
      product: [
        v => !!v || 'Select Product type'
      ],
    },
    subdomainErrors: [],
    subdomainSuccess: []
  }),
  computed: {
    ...mapState('user', ['user']),
    headcounts () {
      let h = this.items.map(i => ({ text: i, value: i }))
      h[0] = { text: h[0].text, value: '1' }
      return h
    },
    phoneSanitized () {
      let phone = this.phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    },
    baseDomain () {
      return process.env.VUE_APP_BASE_DOMAIN
    }
  },
  watch: {
    subdomain (val) {
      this.subdomain = val.toLowerCase().replace(/[\W_]+/g, ' ').replace(/ /g, '-')
    }
  },
  mounted () {
    if (!this.user) {
      this.$router.push('/')
      return
    }
    
    if (this.subdomainRequired) {
      this.showSubDomainAlert = true
    }
    this.datta = Cookies.get('project_id')

    if (this.user.auth_phone) {
      let [phoneNumber] = this.sanitizePhone(this.user.auth_phone, true)
      if (phoneNumber.charAt(0) === '6') {
        phoneNumber = phoneNumber.substring(1)
      }
      this.phone = phoneNumber
    }
    this.getSupportedCurrencies()
  },
  methods: {
    ...mapActions([
      'updateCompany'
    ]),
    getSupportedCurrencies () {
      this.$axios.get('/companies/supported_currencies/')
        .then(resp => {
          this.currencies = resp.data
          const zoneId = DateTime.local().toFormat('z')
          const country = this.$options.filters.getCountryCodeFromZoneId(zoneId)
          const countryCurrency = this.currencies.filter(f => f.country_code == country)[0]
          if (countryCurrency) {
            this.currency = countryCurrency.currency_code
          }
        })
        .catch(() => {})
    },
    sanitizePhone (phone, returnAlias = false) {
      let alias = null
      if (!phone) {
        phone = ''
      }
      phone = phone.trim()
      if (phone.includes('+') && phone.charAt(0) !== '+') {
        let phoneComponents = phone.split('+')
        alias = phoneComponents[0].trim()
        phone = phoneComponents[1]
      }
      phone = phone.trim().replace('-', '').replace(' ', '').replace('+', '')
      if (phone && phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      if (returnAlias) {
        if (alias) {
          return [phone, `${alias}+${phone}`]
        } else {
          return [phone, phone]
        }
      } else {
        return phone
      }
    },
    onFocusSubdomain () {
      this.subdomainSuccess = []
      this.subdomainErrors = []
    },
    checkSubdomain () {
      if (this.$refs.subdomain.valid) {
        this.$axios.get('/companies/check_slug/', { params: { slug: this.subdomain } })
          .then(resp => {
            if (resp.data.available) {
              this.subdomainSuccess = [`${this.subdomain}.${this.baseDomain} is available! Yezza!`]
              this.subdomainErrors = []
            } else {
              this.subdomainErrors = [`${this.subdomain}.${this.baseDomain} is not available  `]
              this.subdomainSuccess = []
            }
          })
          .catch(() => {})
      } else {
        this.subdomainSuccess = []
        this.subdomainErrors = []
      }
    },
    async submit () {
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }
      this.loading = true
      let data = {
        name: this.name,
        slug: this.subdomain,
        os: this.os,
        primary_owner_user_id: this.user.id,
        primary_owner_phone: this.phoneSanitized,
        headcount: this.headcount,
        plan: this.selectedPlan || 2,
        extra_data: this.companyExtraData,
        fbq: {
          cookies: Cookies.get(),
          user_agent: navigator.userAgent
        },
        currency: this.currency
      }

      if (this.$store.state.ui.affiliateId && this.$store.state.ui.affiliateId !== 'undefined') {
        data.partner = this.$store.state.ui.affiliateId
        Cookies.remove('af_id')
        this.$store.commit('ui/setAffiliateId', null)
      }

      try {
        const companyCreateResp = await this.$axios.post('/companies/', data)
        const company = companyCreateResp.data
        let contract = ''
        
        if (this.datta) {
          const sponsorResp = await this.$axios.get(`/sponsors/${this.datta}`)
          const sponsor = sponsorResp.data
          const subscription = {
            company: company.id,
            contract: sponsor.contract,
            promo: sponsor.promo
          }
          await this.$axios.post(`/subscription/subscriptions/`, subscription)
          Cookies.remove('project_id')
        } else {
          
            contract = 'YZ_CLINIC_PLAN_TRIAL'
            const subscription = {
              company: company.id,
              contract: contract
            }
            await this.$axios.post(`/subscription/subscriptions/`, subscription)
            await this.$axios.get(`/clinics/${this.subdomain}`)
        }

        //-this.$axios.post(`/companies/${company.id}/start_trial/`)
        if (this.$store.state.user.referralCode) {
          await this.$axios.post(`/companies/${company.id}/apply_referral_code/`, {'campaign': 'pkp', 'code': this.$store.state.user.referralCode})
          this.$store.commit('user/setReferralCode', null)
        }

        // Tracking
        this.trackGtag()

        // Get company subscriptions
        this.$axios.get(`/subscription/subscriptions/?company=${company.id}&terminated=false&ordering=start_date&expand=contract&page_size=1000`)
        .then((response) => {
          this.$store.commit('subscriptions/setSubscriptions', response.data.results)
          this.$store.commit('subscriptions/setDefaultFeature', company)
        },()=>{})

        // Get company genes
        this.$axios.get(`/companies/${company.id}/genes`)
        .then((response) => {
          this.$store.commit('subscriptions/setLimitations', response.data)
          this.$store.commit('subscriptions/setGenes', response.data)
        },()=>{})

        // Update company
        const companyResp = await this.$axios.get(`/companies/${company.id}/`)
        this.updateCompany(companyResp.data)
        
        this.$router.push('/signup/appointment/subscribe')
      } finally {
        this.loading = false
      }
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.event('sign_up')
        this.$gtag.event('StartTrial')
      })
    },
    trackPixel (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'StartTrial', {value: '0.00', currency: 'MYR'}, {eventID: eventID})
    },
    trackPixelBooks (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZABOOKS_FB_PIXEL_ID, 'StartTrial', {value: '0.00', currency: 'MYR'}, {eventID: eventID})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
</style>

<i18n>
{
  "en": {
    "tell_us_about": "Tell us about your Clinic",
    "about_subdomain": "About Subdomain",
    "about_subdomain_desc": "Any subdomain referring to <b>trademark without consent</b> is not applicable ie: Petronas, Shell, McD</br></br>Subdomains that are <b>reserved for our system</b> will also not be applicable ie blog, shop, marketplace etc.</br></br>In such cases, <b>we have the right to reclaim the subdomain</b>",
    "i_understand": "I Understand",
    "company_name": "Clinic Name",
    "company_name_placeholder": "The Name of Your Clinic ",
    "subdomain": "Subdomain",
    "staff_count": "Staff Count",
    "staff_count_placeholder": "Select number of staff",
    "business_category": "Clinic category",
    "business_category_placeholder": "Select your clinic category",
    "enter_business_category": "Enter business category",
    "currency": "Currency",
    "currency_placeholder": "Select account currency",
    "trial_plan": "Trial plan",
    "trial_plan_placeholder": "Select Plan",
    "select_trial_plan": "Select your trial plan for this company"
  },
  "id": {
    "tell_us_about": "Daftar Klinik",
    "about_subdomain": "Tentang Subdomain",
    "about_subdomain_desc": "Setiap subdomain yang mengacu pada <b>merek dagang tanpa persetujuan</b> tidak berlaku yaitu: Petronas, Shell, McD</br></br>Subdomain yang <b>dicadangkan untuk sistem kami</b> juga tidak akan yang berlaku yaitu blog, toko, pasar, dll.</br></br>Dalam kasus tersebut, <b>kami berhak mengklaim kembali subdomain</b>",
    "i_understand": "Saya mengerti",
    "company_name": "Nama perusahaan",
    "company_name_placeholder": "Masukkan nama perusahaan",
    "subdomain": "Subdomain",
    "staff_count": "Jumlah staf",
    "staff_count_placeholder": "Pilih jumlah staf",
    "business_category": "Kategori perusahaan",
    "business_category_placeholder": "Pilih kategori perusahaan",
    "enter_business_category": "Masukkan kategori perusahaan",
    "currency": "mata uang",
    "currency_placeholder": "Pilih mata uang",
    "trial_plan": "Paket Trial",
    "trial_plan_placeholder": "Pilih Paket",
    "select_trial_plan": "Pilih paket trial untuk perusahaan kamu"
  }
}
</i18n>
